export const REQUEST_PROCESSES_DATA = 'REQUEST_PROCESSES_DATA';
export const FETCH_PROCESSES_SUCCEEDED = 'FETCH_PROCESSES_SUCCEEDED';
export const FETCH_PROCESSES_FAILED = 'FETCH_PROCESSES_FAILED';
export const LOADING_PROCESSES = 'LOADING_PROCESSES';

export const REQUEST_POLICY_HOLDERS_DATA = 'REQUEST_POLICY_HOLDERS_DATA';
export const FETCH_POLICY_HOLDERS_SUCCEEDED = 'FETCH_POLICY_HOLDERS_SUCCEEDED';
export const FETCH_POLICY_HOLDERS_FAILED = 'FETCH_POLICY_HOLDERS_FAILED';
export const RESET_POLICY_HOLDERS = 'RESET_POLICY_HOLDERS';

export const UPDATE_BROKER_DATA = 'UPDATE_BROKER_DATA';

// User Edit
export const REQUEST_USER_DATA = 'REQUEST_USER_DATA';
export const FETCH_USER_SUCCEEDED = 'FETCH_USER_SUCCEEDED';
export const FETCH_USER_FAILED = 'FETCH_USER_FAILED';
